import { Routes } from '@angular/router';
import { HomePage } from './pages/home/home-page';
import { AdvancedSearch } from './pages/advanced-search/advanced-search';
import { Libraries } from './pages/libraries/libraries';
import { IndexDetails } from './pages/index-details/index-details';
import { ContactUs } from './pages/contact-us/contact-us';
import { RegisterComponent } from './pages/auth/register.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password.component';

import { NotFound } from './pages/not-found/not-found';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomePage },
    { path: 'advanced-search', component: AdvancedSearch },
    {
        path: 'browse-index',
        loadChildren: () =>
            import('./features/browse-index/browse-index.routes')
                .then(m => m.BROWSE_INDEX_ROUTES),
    },
    { path: 'libraries', component: Libraries },
    { path: 'index-details/:id', component: IndexDetails },
    { path: 'index-details', component: IndexDetails },  // fallback: query-param ?id=
    { path: 'contact-us', component: ContactUs },
    { path: 'register', component: RegisterComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    {
        path: 'my-account',
        loadChildren: () => import('./pages/my-account/my-account.routes').then(m => m.MY_ACCOUNT_ROUTES)
    },
    { path: '**', component: NotFound }
];

